export default __webpack_public_path__ + "static/media/talent_main-section-logo-airbnb-Dev-IT.eb443eb9.svg";